/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{fromValues as e}from"../../../../../../core/libs/gl-matrix-2/factories/vec4f64.js";import{glsl as o}from"../../shaderModules/interfaces.js";import{Texture2DPassUniform as t}from"../../shaderModules/Texture2DPassUniform.js";const r=e(1,1,0,1),d=e(1,0,1,1);function a(e){e.fragment.uniforms.add(new t("depthTexture",((e,o)=>o.mainDepth))),e.fragment.constants.add("occludedHighlightFlag","vec4",r).add("unoccludedHighlightFlag","vec4",d),e.fragment.code.add(o`void outputHighlight() {
float sceneDepth = float(texelFetch(depthTexture, ivec2(gl_FragCoord.xy), 0).x);
if (gl_FragCoord.z > sceneDepth + 5e-7) {
fragColor = occludedHighlightFlag;
} else {
fragColor = unoccludedHighlightFlag;
}
}`)}export{a as OutputHighlight,r as occludedHighlightFlag,d as unoccludedHighlightFlag};
